import { useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Title } from 'components/Title';

import { Toast } from 'primereact/toast'; // ✅ Fixed import
import axios from 'axios';
import AddItemsToBooking from './AddItemsToBooking';
import { InputText } from 'primereact/inputtext';
export default function AdditemsPage() {
	
	const [pageReady, setPageReady] = useState(true);
	  const API_BASE_URL = process.env.REACT_APP_API_PATH || 'https://localhost:7000/api';
  const toast = useRef(null);
  const [searchReference, setSearchReference] = useState('');
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchError, setSearchError] = useState(null);
  const [showItemsForm, setShowItemsForm] = useState(false);
  const [bookingDetails, setBookingDetails] = useState(null);
  const handleSearch = async () => {
    if (!searchReference.trim()) {
      toast.current?.show({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please enter a booking reference',
        life: 3000
      });
      return;
    }
    setSearchLoading(true);
    setSearchError(null);
    try {
      // First validate the booking
      const response = await axios.get(`${API_BASE_URL}BookingItems/validate/${searchReference}`);
      if (response.data.success && response.data.isValid) {
        // Fetch booking details
        const bookingResponse = await axios.get(`${API_BASE_URL}BookingItems/booking/${searchReference}`);
        if (bookingResponse.data.success) {
          setBookingDetails(bookingResponse.data.data);
          setSelectedBooking({ bookingReference: searchReference });
          setShowItemsForm(true); // This will show the item entry form
          toast.current?.show({
            severity: 'success',
            summary: 'Success',
            detail: response.data.message,
            life: 3000
          });
        }
      } else {
        setSearchError(response.data.message || 'Booking cannot accept items at this stage');
        toast.current?.show({
          severity: 'error',
          summary: 'Invalid',
          detail: response.data.message || 'Booking cannot accept items',
          life: 3000
        });
      }
    } catch (error) {
      const message = error.response?.data?.message || 'Booking not found';
      setSearchError(message);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: message,
        life: 3000
      });
    } finally {
      setSearchLoading(false);
    }
  };
  const handleItemsAdded = (updatedBooking) => {
    setBookingDetails(updatedBooking);
    toast.current?.show({
      severity: 'success',
      summary: 'Success',
      detail: 'Items added successfully! You can add more items or search for another order.',
      life: 5000,
      sticky: true
    });
  };
  const handleBackToSearch = () => {
    setShowItemsForm(false);
    setSelectedBooking(null);
    setBookingDetails(null);
    setSearchReference('');
    setSearchError(null);
  };
  const handleCompleteOrder = () => {
    setShowItemsForm(false);
    setSelectedBooking(null);
    setBookingDetails(null);
    setSearchReference('');
    setSearchError(null);
    toast.current?.show({
      severity: 'success',
      summary: 'Order Completed',
      detail: 'Order has been completed successfully!',
      life: 3000
    });
  };
  // If showing items form, render AddItemsToBooking component
  if (showItemsForm && selectedBooking) {
    return (
      <main id="AdditemsPage" className="main-page">
        <section className="page-section q-pa-md">
          <div className="container-fluid">
            <div className="grid">
              <div className="col comp-grid">
                <Title 
                  title="Add Items to Booking" 
                  titleClass="text-lg font-bold text-primary" 
                  subTitleClass="text-500" 
                  separator={false} 
                />
                <AddItemsToBooking
                  bookingReference={selectedBooking.bookingReference}
                  bookingDetails={bookingDetails}
                  onItemsAdded={handleItemsAdded}
                  onBackToSearch={handleBackToSearch}
                  onCompleteOrder={handleCompleteOrder}
                />
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
	return (
		<main id="AdditemsPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title="AddItems"   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div className="staff-pickup-portal p-4">
                        <Toast ref={toast} />
                        <Card className="shadow-2">
                        <div className="text-center mb-4">
                            <h1 className="text-3xl mb-2">Staff Pickup Portal</h1>
                            <p className="text-gray-600">Search and add items to booking orders</p>
                        </div>
                        <div className="flex flex-column align-items-center">
                            <div className="w-full md:w-8 lg:w-6">
                                <div className="p-inputgroup">
                                    <InputText
                                    placeholder="Enter Booking Reference (e.g., 20260330-00001)"
                                    value={searchReference}
                                    onChange={(e) => setSearchReference(e.target.value)}
                                    onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                                    disabled={searchLoading}
                                    className="w-full"
                                    />
                                    <Button
                                    label="Search"
                                    icon="pi pi-search"
                                    onClick={handleSearch}
                                    disabled={searchLoading}
                                    loading={searchLoading}
                                    />
                                </div>
                                {searchError && (
                                <div className="mt-3 p-3 bg-red-50 border-round text-red-700">
                                    <i className="pi pi-exclamation-triangle mr-2"></i>
                                    {searchError}
                                </div>
                                )}
                                <div className="mt-4 text-center text-gray-500">
                                    <i className="pi pi-info-circle mr-2"></i>
                                    Enter booking reference to add items and generate bill
                                </div>
                            </div>
                        </div>
                        </Card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
